import React, { useState, useEffect } from 'react';
import { getPublicAssetCategories } from '../../api/assetsApi';
import CustomDatePicker from '../common/CustomDatePicker';

function RequestAssetForm({ formData, onFormDataChange, fieldErrors = {} }) {
  const [assetCategories, setAssetCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await getPublicAssetCategories();
        setAssetCategories(response.data);
      } catch (err) {
        console.error('Failed to load asset categories:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  const handleInputChange = (field, value) => {
    onFormDataChange({
      ...formData,
      [field]: value,
    });
  };

  if (loading) {
    return <div className="text-center">Loading categories...</div>;
  }

  return (
    <div className="row g-3">
      <div className="col-md-6">
        <div className="mb-3">
          <label htmlFor="assetName" className="form-label">
            Name <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            id="assetName"
            placeholder="Asset name"
            value={formData.name || ''}
            onChange={(e) => handleInputChange('name', e.target.value)}
            required
          />
        </div>

        <div className="mb-3">
          <label htmlFor="description" className="form-label">
            Description <span className="text-danger">*</span>
          </label>
          <textarea
            className={`form-control ${fieldErrors.description ? 'is-invalid' : ''}`}
            id="description"
            rows="7"
            placeholder="Please describe the asset."
            value={formData.description || ''}
            onChange={(e) => handleInputChange('description', e.target.value)}
            required
          />
          {fieldErrors.description && <div className="invalid-feedback">{fieldErrors.description}</div>}
        </div>
      </div>

      <div className="col-md-6">
        <div className="mb-3">
          <label htmlFor="assetCategory" className="form-label">
            Category <span className="text-danger">*</span>
          </label>
          <select
            className="form-control"
            id="assetCategory"
            value={formData.categoryId || ''}
            onChange={(e) => handleInputChange('categoryId', e.target.value)}
            required>
            <option value="">Category</option>
            {assetCategories.map((category) => (
              <option key={category.assetCategoryId} value={category.assetCategoryId}>
                {category.name}
              </option>
            ))}
          </select>
        </div>

        <div className="mb-3">
          <label htmlFor="startingFrom" className="form-label">
            Starting from <span className="text-danger">*</span>
          </label>
          <CustomDatePicker
            value={formData.startingFrom || ''}
            onChange={(value) => handleInputChange('startingFrom', value)}
            placeholder="Select starting date"
            className="form-control"
          />
        </div>

        <div className="mb-3">
          <label htmlFor="price" className="form-label">
            Price (€)
          </label>
          <input
            type="number"
            className="form-control"
            id="price"
            placeholder="e.g., €67.99"
            step="0.01"
            min="0"
            value={formData.price || ''}
            onChange={(e) => handleInputChange('price', e.target.value)}
          />
          <small className="form-text text-muted">An approximate amount is fine; it helps the admins evaluate your request.</small>
        </div>
      </div>
    </div>
  );
}

export default RequestAssetForm;
